import styled from 'styled-components'

import { Tag } from '@icontainers/design-system/dist/molecules/Tag'
import { Tooltip as TooltipBase } from '@icontainers/design-system/dist/molecules/Tooltip'
import { Link } from '@src/Application/Interfaces/Atoms/Link'
import { ArrowDirectionIcon } from '@src/Application/Interfaces/Icons'

export const Wrapper = styled.div`
    border-radius: 3px;
    ${(props) => props.theme.boxShadow.level1};
    background-color: ${(props) => props.theme.color.white};
    display: flex;
    flex-direction: column;

    @media ${(props) => props.theme.query.min.tablet} {
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        min-height: 61px;
    }
`
export const RouteContent = styled.div`
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    flex-direction: column;
    align-items: start;

    @media ${(props) => props.theme.query.min.tablet} {
        flex-direction: row;
        align-items: center;
    }
`

const Type = styled(Tag)`
    text-transform: uppercase;
`

export const TypeDesktop = styled(Type)`
    display: none;

    @media ${(props) => props.theme.query.min.tablet} {
        display: block;
        margin-right: 10px;
    }
`

export const TypeMobile = styled(Type)`
    display: block;

    @media ${(props) => props.theme.query.min.tablet} {
        display: none;
    }
`

export const Location = styled.div`
    ${(props) => props.theme.typo.bodyM};
    display: flex;
    margin-bottom: 10px;
    flex: 1;
    align-items: center;

    i {
        flex-shrink: 0;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        margin-bottom: 0;
    }
`

export const LocationName = styled.div`
    margin-left: 5px;
`

export const LocationTooltip = styled(TooltipBase)`
    margin-left: 5px;
`

export const RouteLinkWrapper = styled.div`
    padding: 10px;
    display: flex;
    justify-content: space-between;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 0px;
        display: block;
    }
`

export const RouteLinkDesktop = styled.a`
    display: none;

    @media ${(props) => props.theme.query.min.tablet} {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: ${(props) => props.theme.color.p500};
        border-radius: 3px;
        height: 100%;
        border-radius: 0px 3px 3px 0px;
    }
`
export const RouteLinkMobile = styled(Link)`
    @media ${(props) => props.theme.query.min.tablet} {
        display: none;
    }
`

export const Arrow = styled(ArrowDirectionIcon)`
    margin-left: 5px;
    margin-right: 20px;
    margin-bottom: 10px;

    @media ${(props) => props.theme.query.min.tablet} {
        margin-bottom: 0;
        margin-left: 20px;
    }
`

export const RouteLinkArrow = styled(ArrowDirectionIcon)`
    margin-left: 16px;
    margin-right: 16px;
`

export const Price = styled.div`
    color: ${(props) => props.theme.color.g500};
    ${(props) => props.theme.typo.bodyS}

    span {
        margin-left: 6px;
        display: block;
        ${(props) => props.theme.typo.bodyM}
        color: ${(props) => props.theme.color.black};
    }
`

export const PriceDesktop = styled(Price)`
    display: none;

    @media ${(props) => props.theme.query.min.tablet} {
        display: flex;
        align-items: center;
        padding-right: 20px;
        min-width: 115px;
    }
`

export const PriceMobile = styled(Price)`
    display: flex;
    align-items: center;

    @media ${(props) => props.theme.query.min.tablet} {
        display: none;
    }
`
